export const ATTACHMENT_TYPE_SHAREPOINT = "sharepointfileattachment";
export const ATTACHMENT_TYPE_NORMAL = "fileattachment";
